<template>
  <v-app>
    <AppHeader />
    <v-main>
      <v-container fluid>
        <v-alert v-if="getFeedback" :text="getFeedback" type="warning" @click="$store.commit('setFeedback',null)"/>
        <router-view/>
      </v-container>
      <v-card-text>
        v. 2026-08-31 (c) jskalka@ukf.sk Fakulta prírodných vied a informatiky, UKF v Nitre
      </v-card-text>

    </v-main>
  </v-app>
</template>

<script>
import AppHeader from './components/app_header.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'App',
  data: () => ({
    //
  }),
  computed: mapGetters([
            'getFeedback'
        ]),
  components: {
    AppHeader
  },
  created() {
    if (localStorage != null) {
        if (localStorage.getItem('confirm') == null || localStorage.getItem('confirm') != '1')
          this.$store.dispatch('tryAutologin')
    }
  }
}
</script>

